const { DateTime } = luxon;
// const shopTz = window.shopSettings.timezone || "Europe/London";
const shopTz = window.shopSettings.timezone;

const today = new Date();
let currentMonth = today.getMonth();
let currentYear = today.getFullYear();
let selectedDate = null;
let calendarID = null;
let selectedDateTime = null;
// Separate month/year for each calendar type
let visitUsMonth = new Date().getMonth();
let visitUsYear = new Date().getFullYear();

let vanStepsMonth = new Date().getMonth();
let vanStepsYear = new Date().getFullYear();

let calendarType = "store"; // or "van"

function getCurrentMonth() {
  return calendarType === "van" ? vanStepsMonth : visitUsMonth;
}
function getCurrentYear() {
  return calendarType === "van" ? vanStepsYear : visitUsYear;
}

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

async function renderCalendar(month, year, calendar_Id) {
  calendarID = window?.shopSettings?.calendarId;
  let calendarType = window?.shopSettings?.calendarType;
  let daysContainer = document.querySelector(`${calendarType} #days-container`);
  let monthYearDisplay = document.querySelector(`${calendarType} #month-year`);
  let timeSlotsContainer = document.querySelector(
    `${calendarType} #time-slots`
  );
  let loadingSpinner = document.querySelector(
    `${calendarType} .calendar-loader`
  );
  console.log(calendarType, "calendarType calendar");
  if (daysContainer) {
    daysContainer.innerHTML = "";
  } else {
    timeSlotsContainer.innerHTML = "";
  }
  monthYearDisplay.textContent = `${monthNames[month]} ${year}`;

  const firstDay = new Date(year, month, 1).getDay(); // 0 = Sunday
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const startDay = firstDay === 0 ? 6 : firstDay - 1;
  console.log(
    calendarID,
    window?.shopSettings?.calendarId,
    calendarID,
    "calendarID"
  );

  loadingSpinner.style.display = "flex";
  // Fetch calendar events from the API
  await fetch(
    `${
      window.shopSettings.calendarApiServerUrl
    }/api/events?month=${year}-${String(month + 1).padStart(
      2,
      "0"
    )}&calendarID=${calendarID}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => response.json())
    .then((events) => {
      loadingSpinner.style.display = "none";
      // Add blank days
      for (let i = 0; i < startDay; i++) {
        daysContainer.innerHTML += "<li></li>";
      }

      for (let day = 1; day <= daysInMonth; day++) {
        const currentDate = new Date(year, month, day);
        const isToday =
          day === today.getDate() &&
          month === today.getMonth() &&
          year === today.getFullYear();

        const dayElement = document.createElement("li");
        const spanElement = document.createElement("span");

        // --- VAN LOGIC: Only enable days matching slots weekdays ---
        let isVanAvailableDay = true;
        let vanSlot = null;
        // Accept both "van" and ".vanSteps" as calendarType
        // const isVanCalendar =
        //   calendarType === "van" || calendarType === ".vanSteps";
        // if (isVanCalendar && Array.isArray(window.shopSettings?.slots)) {
        //   // Get weekday name for currentDate (e.g., "Monday")
        //   const weekdayName = currentDate.toLocaleDateString("en-US", {
        //     weekday: "long",
        //   });
        //   vanSlot = window.shopSettings.slots.find(
        //     (slot) => slot.day === weekdayName
        //   );
        //   isVanAvailableDay = !!vanSlot;
        // }
        const isSlotCalendar =
          Array.isArray(window.shopSettings?.slots) &&
          window.shopSettings.slots.length > 0;

        let isAvailableDay = true;
        let slotForDay = null;

        if (isSlotCalendar) {
          // Get weekday name for currentDate (e.g., "Monday")
          const weekdayName = currentDate.toLocaleDateString("en-US", {
            weekday: "long",
          });
          slotForDay = window.shopSettings.slots.find(
            (slot) => slot.day === weekdayName
          );
          isAvailableDay = !!slotForDay;
        }
        const appointment_duration =
          window.shopSettings.appointment_duration || 10;
        const appointment_delay = window.shopSettings.appointment_delay || 5;
        // Check if the current date has an event
        const dayEvents = events.filter((event) => {
          const eventDate = new Date(event.start);
          return (
            eventDate.getDate() === day &&
            eventDate.getMonth() === month &&
            eventDate.getFullYear() === year
          );
        });

        // --- VAN LOGIC: Only enable days matching slots weekdays ---
        // if (isVanCalendar && !isVanAvailableDay) {
        //   spanElement.classList.add("disabledDates");
        // } else if (isToday) {
        //   spanElement.classList.add("otherDates");
        // } else if (currentDate < today) {
        //   spanElement.classList.add("disabledDates");
        // } else {
        //   spanElement.classList.add("otherDates");
        // }
        if (isSlotCalendar && !isAvailableDay) {
          spanElement.classList.add("disabledDates");
        } else if (isToday) {
          spanElement.classList.add("otherDates");
        } else if (currentDate < today) {
          spanElement.classList.add("disabledDates");
        } else {
          spanElement.classList.add("otherDates");
        }

        spanElement.textContent = day;

        // Always allow click if day is not disabled by van logic or past
        // if (!(isVanCalendar && !isVanAvailableDay) && currentDate >= today) {
        //   spanElement.addEventListener("click", () => {
        //     selectedDate = new Date(year, month, day);
        //     document.querySelectorAll(".days li span").forEach((span) => {
        //       span.classList.remove("activeDates");
        //     });
        //     spanElement.classList.add("activeDates");
        //     // For van, use slot times; for store, use default
        //     if (isVanCalendar && vanSlot) {
        //       const from = DateTime.fromISO(vanSlot.from_time, {
        //         zone: "utc",
        //       }).setZone(shopTz);
        //       const to = DateTime.fromISO(vanSlot.to_time, {
        //         zone: "utc",
        //       }).setZone(shopTz);

        //       const fromHour = from.hour;
        //       const fromMinute = from.minute;
        //       const toHour = to.hour;
        //       const toMinute = to.minute;

        //       renderTimeSlot(
        //         selectedDate,
        //         fromHour + fromMinute / 60,
        //         toHour + toMinute / 60,
        //         30,
        //         15,
        //         dayEvents // <-- pass the day's events to disable only those slots
        //       );
        //     } else {
        //       renderTimeSlot(selectedDate, 9, 22, 30, 15, dayEvents);
        //     }
        //   });
        // }
        if (!(isSlotCalendar && !isAvailableDay) && currentDate >= today) {
          spanElement.addEventListener("click", () => {
            selectedDate = new Date(year, month, day);
            document.querySelectorAll(".days li span").forEach((span) => {
              span.classList.remove("activeDates");
            });
            spanElement.classList.add("activeDates");
            // For both store and van, use slot times if available
            if (isSlotCalendar && slotForDay) {
              console.log("Slot for day:", slotForDay);
              const shopTz = window.shopSettings.timezone || "Europe/London";
              const from = DateTime.fromISO(slotForDay.from_time, {
                zone: "utc",
              }).setZone(shopTz);
              const to = DateTime.fromISO(slotForDay.to_time, {
                zone: "utc",
              }).setZone(shopTz);

              const fromHour = from.hour;
              const fromMinute = from.minute;
              const toHour = to.hour;
              const toMinute = to.minute;

              renderTimeSlot(
                selectedDate,
                fromHour + fromMinute / 60,
                toHour + toMinute / 60,
                appointment_duration,
                appointment_delay,
                dayEvents
              );
            } else {
              renderTimeSlot(
                selectedDate,
                9,
                22,
                appointment_duration,
                appointment_delay,
                dayEvents
              );
            }
          });
        }

        dayElement.appendChild(spanElement);
        daysContainer.appendChild(dayElement);
      }
    })
    .catch((error) => console.error("Error fetching events:", error));
  // Button event listeners
  const prevButton = document.querySelector(`${calendarType} #prevMonth`);
  const nextButton = document.querySelector(`${calendarType} #nextMonth`);
  // prevButton.addEventListener("click", () => changeMonth(-1));
  // nextButton.addEventListener("click", () => changeMonth(1));

  // nextButton.addEventListener("click", function () {
  //   currentMonth++;
  //   if (currentMonth > 11) {
  //     currentMonth = 0;
  //     currentYear++;
  //   }
  //   renderCalendar(currentMonth, currentYear, calendarID, calendarType);
  // });

  // prevButton.addEventListener("click", function () {
  //   currentMonth--;
  //   if (currentMonth < 0) {
  //     currentMonth = 11;
  //     currentYear--;
  //   }
  //   renderCalendar(currentMonth, currentYear, calendarID, calendarType);
  // });
}

async function renderTimeSlot(
  date,
  startTime = 9,
  endTime = 22,
  slotDuration = 30,
  delayDuration = 15,
  events = []
) {
  calendarID = window?.shopSettings?.calendarId;
  let calendarType = window?.shopSettings?.calendarType;
  let daysContainer = document.querySelector(`${calendarType} #days-container`);
  let monthYearDisplay = document.querySelector(`${calendarType} #month-year`);
  let calendarContainer = document.querySelector(`${calendarType} .calendar`);
  let loadingSpinner = document.querySelector(
    `${calendarType} .calendar-loader`
  );
  console.log(calendarContainer);
  calendarContainer.classList.remove("full-width");
  calendarContainer.classList.add("half-width");
  // timeSlotContainer.classList.add("half-width");

  let timeSlotsContainer = document.querySelector(
    `${calendarType} #time-slots`
  );
  let timeSlotsContainerMain = document.querySelector(
    `${calendarType} .timeSlots`
  );
  // Remove existing time slots and header if present
  if (timeSlotsContainerMain) {
    // Remove existing #time-slots list
    if (timeSlotsContainer) {
      timeSlotsContainer.remove();
    }

    // Remove existing h2 header if present
    const existingHeader = timeSlotsContainerMain.querySelector("h2");
    if (existingHeader) {
      existingHeader.remove();
    }

    // Create and add new header
    const header = document.createElement("h2");
    header.textContent = "Available Time Slots";
    header.style.textAlign = "center";
    timeSlotsContainerMain.appendChild(header);

    // Clear and re-append the time slots container
    timeSlotsContainer.innerHTML = "";
    timeSlotsContainerMain.appendChild(timeSlotsContainer);

    timeSlotsContainerMain.classList.add("half-width");
  }
  console.log(calendarType, "calendarType");

  // Clear existing slots
  const visitSteps = document.querySelectorAll(`${calendarType} .visit-step`);

  if (!date) return; // No date selected

  let slotsAdded = false;

  // for (let hour = startTime; hour < endTime; hour++) {
  //   for (let minute = 0; minute < 60; minute += slotDuration + delayDuration) {
  //     const time = new Date(date);
  //     time.setHours(hour, minute, 0);

  //     const formattedTime = time.toLocaleTimeString([], {
  //       hour: "2-digit",
  //       minute: "2-digit",
  //       hour12: true,
  //     });

  //     const slotButton = document.createElement("button");
  //     slotButton.className = "time-slot-btn";
  //     slotButton.textContent = formattedTime;

  //     // Check if the time slot overlaps with any event
  //     const isDisabled = events.some((event) => {
  //       const eventStart = new Date(event.start);
  //       const eventEnd = new Date(event.end);
  //       return time >= eventStart && time < eventEnd;
  //     });

  //     if (isDisabled) {
  //       slotButton.disabled = true;
  //       slotButton.style.opacity = "0.5";
  //       slotButton.style.cursor = "not-allowed";
  //     } else {
  //       slotButton.addEventListener("click", async () => {
  //         document
  //           .querySelectorAll(".time-slot-btn")
  //           .forEach((btn) => btn.classList.remove("selected"));
  //         slotButton.classList.add("selected");

  //         // Format the selected date and time
  //         const selectedDateStr = date.toLocaleDateString([], {
  //           year: "numeric",
  //           month: "short",
  //           day: "numeric",
  //         });
  //         const selectedTimeStr = time.toLocaleTimeString([], {
  //           hour: "2-digit",
  //           minute: "2-digit",
  //           hour12: true,
  //         });
  //         console.log(visitSteps[1], "visitSteps[1]");
  //         visitSteps[1].querySelector(".check-icon").style.display = "block";
  //         // Update the summary card
  //         const appointmentSummary = document.getElementById(
  //           "appointment-summary"
  //         );
  //         const appointmentDatetime = document.getElementById(
  //           "appointment-datetime"
  //         );
  //         if (appointmentSummary && appointmentDatetime) {
  //           appointmentDatetime.textContent = `${selectedDateStr} at ${selectedTimeStr}`;
  //           appointmentSummary.style.display = "block";
  //         }
  //         selectedDateTime = {
  //           date: selectedDateStr,
  //           time: selectedTimeStr,
  //           start: time.toISOString(),
  //           end: new Date(time.getTime() + slotDuration * 60000).toISOString(),
  //         };
  //         window.shopSettings.selectedDateTime = selectedDateTime;
  //         console.log("Selected Date and Time:", window.selectedDateTime);
  //         if (selectedDateTime) {
  //           document.querySelector(".continue-btn").disabled = false;
  //           document.querySelector(".continue-btn").classList.add("active");
  //           document.querySelector(".continue-btn-mbl").disabled = false;
  //           document.querySelector(".continue-btn-mbl").classList.add("active");
  //         }
  //         // Hit create event API
  //         // await fetch(
  //         //   `${window.shopSettings.calendarApiServerUrl}/api/events?&calendarID=${calendarID}`,
  //         //   {
  //         //     method: "POST",
  //         //     headers: {
  //         //       "Content-Type": "application/json",
  //         //     },
  //         //     body: JSON.stringify({
  //         //       summary: "event from calendar",
  //         //       description: "event from calendar",
  //         //       start: time.toISOString(),
  //         //       end: new Date(
  //         //         time.getTime() + slotDuration * 60000
  //         //       ).toISOString(),
  //         //     }),
  //         //   }
  //         // )
  //         //   .then((response) => {
  //         //     if (response.ok) {
  //         //       loadingSpinner.style.display = "none";
  //         //       alert("Event created successfully!");
  //         //     } else {
  //         //       alert("Failed to create event.");
  //         //     }
  //         //   })
  //         //   .catch((error) => console.error("Error creating event:", error));
  //         visitSteps.forEach((step) => step.classList.remove("active"));

  //         // Add 'active' to Step 2 (index 1)
  //         // visitSteps[2].classList.add("active");
  //       });
  //       slotsAdded = true;
  //     }

  //     const listItem = document.createElement("li");
  //     listItem.appendChild(slotButton);
  //     timeSlotsContainer.appendChild(listItem);
  //   }
  // }
  let slotStart = new Date(date);
  slotStart.setHours(
    Math.floor(startTime),
    Math.round((startTime % 1) * 60),
    0,
    0
  );

  let slotEnd = new Date(date);
  slotEnd.setHours(Math.floor(endTime), Math.round((endTime % 1) * 60), 0, 0);

  let currentSlot = new Date(slotStart);

  while (currentSlot < slotEnd) {
    const formattedTime = currentSlot.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    const slotButton = document.createElement("button");
    slotButton.className = "time-slot-btn";
    slotButton.textContent = formattedTime;

    // Check if the time slot overlaps with any event
    const isDisabled = events.some((event) => {
      const eventStart = new Date(event.start);
      const eventEnd = new Date(event.end);
      return currentSlot >= eventStart && currentSlot < eventEnd;
    });

    if (isDisabled) {
      slotButton.disabled = true;
      slotButton.style.opacity = "0.5";
      slotButton.style.cursor = "not-allowed";
    } else {
      slotButton.addEventListener("click", async () => {
        document
          .querySelectorAll(".time-slot-btn")
          .forEach((btn) => btn.classList.remove("selected"));
        slotButton.classList.add("selected");

        // Format the selected date and time
        const selectedDateStr = date.toLocaleDateString([], {
          year: "numeric",
          month: "short",
          day: "numeric",
        });
        // const selectedTimeStr = currentSlot.toLocaleTimeString([], {
        //   hour: "2-digit",
        //   minute: "2-digit",
        //   hour12: true,
        // });
        const selectedTimeStr = formattedTime; 
        visitSteps[1].querySelector(".check-icon").style.display = "block";
        // Update the summary card
        const appointmentSummary = document.getElementById(
          "appointment-summary"
        );
        const appointmentDatetime = document.getElementById(
          "appointment-datetime"
        );
        if (appointmentSummary && appointmentDatetime) {
          appointmentDatetime.textContent = `${selectedDateStr} at ${selectedTimeStr}`;
          appointmentSummary.style.display = "block";
        }
        selectedDateTime = {
          date: selectedDateStr,
          time: selectedTimeStr,
          start: currentSlot.toISOString(),
          end: new Date(
            currentSlot.getTime() + slotDuration * 60000
          ).toISOString(),
        };
        console.log(selectedDateTime, "selectedDateTime");
        window.shopSettings.selectedDateTime = selectedDateTime;
        if (selectedDateTime) {
          document.querySelector(".continue-btn").disabled = false;
          document.querySelector(".continue-btn").classList.add("active");
          document.querySelector(".continue-btn-mbl").disabled = false;
          document.querySelector(".continue-btn-mbl").classList.add("active");
        }
        visitSteps.forEach((step) => step.classList.remove("active"));
      });
      slotsAdded = true;
    }

    const listItem = document.createElement("li");
    listItem.appendChild(slotButton);
    timeSlotsContainer.appendChild(listItem);

    // Move to next slot
    currentSlot = new Date(
      currentSlot.getTime() + (slotDuration + delayDuration) * 60000
    );
  }

  if (!slotsAdded) {
    console.log(slotsAdded, "slotsAdded");
    const noSlotsMsg = document.createElement("div");
    noSlotsMsg.textContent = "No slots available";
    noSlotsMsg.classList.add("no-slots-message");
    noSlotsMsg.style.textAlign = "center";
    noSlotsMsg.style.margin = "1em 0";
    timeSlotsContainer.appendChild(noSlotsMsg);
  }
  if (timeSlotsContainerMain) {
    timeSlotsContainerMain.style.display = "block";
  }
}

function changeMonth(offset) {
  calendarID = window?.shopSettings?.calendarId;
  let calendarType = window?.shopSettings?.calendarType;
  let daysContainer = document.querySelector(`${calendarType} #days-container`);
  let monthYearDisplay = document.querySelector(`${calendarType} #month-year`);
  let timeSlotsContainer = document.querySelector(
    `${calendarType} #time-slots`
  );
  if (calendarType === "van") {
    vanStepsMonth += offset;
    if (vanStepsMonth > 11) {
      vanStepsMonth = 0;
      vanStepsYear++;
    } else if (vanStepsMonth < 0) {
      vanStepsMonth = 11;
      vanStepsYear--;
    }
    renderCalendar(vanStepsMonth, vanStepsYear);
  } else {
    visitUsMonth += offset;
    if (visitUsMonth > 11) {
      visitUsMonth = 0;
      visitUsYear++;
    } else if (visitUsMonth < 0) {
      visitUsMonth = 11;
      visitUsYear--;
    }
    renderCalendar(visitUsMonth, visitUsYear);
  }
}

// Example for store
function onStoreSelected(selectedCalendarID) {
  calendarType = "store";
  calendarID = selectedCalendarID;
  renderCalendar(getCurrentMonth(), getCurrentYear(), calendarID, calendarType);
}

// Example for van
function onVanSelected(selectedCalendarID) {
  calendarType = "van";
  calendarID = selectedCalendarID;
  renderCalendar(getCurrentMonth(), getCurrentYear(), calendarID, calendarType);
}
document
  .querySelector(".vanSteps #nextMonth")
  .addEventListener("click", function () {
    if (calendarType === ".vanSteps") {
      vanStepsMonth++;
      if (vanStepsMonth > 11) {
        vanStepsMonth = 0;
        vanStepsYear++;
      }
      renderCalendar(vanStepsMonth, vanStepsYear, calendarID, calendarType);
    } else {
      visitUsMonth++;
      if (visitUsMonth > 11) {
        visitUsMonth = 0;
        visitUsYear++;
      }
      renderCalendar(visitUsMonth, visitUsYear, calendarID, calendarType);
    }
  });

document
  .querySelector(".vanSteps #prevMonth")
  .addEventListener("click", function () {
    if (calendarType === ".vanSteps") {
      vanStepsMonth--;
      if (vanStepsMonth < 0) {
        vanStepsMonth = 11;
        vanStepsYear--;
      }
      renderCalendar(vanStepsMonth, vanStepsYear, calendarID, calendarType);
    } else {
      visitUsMonth--;
      if (visitUsMonth < 0) {
        visitUsMonth = 11;
        visitUsYear--;
      }
      renderCalendar(visitUsMonth, visitUsYear, calendarID, calendarType);
    }
  });

document
  .querySelector(".visitUs #nextMonth")
  .addEventListener("click", function () {
    console.log(visitUsMonth, "visitUsMonth");
    console.log(visitUsMonth, "visitUsMonth");
    if (calendarType === ".vanSteps") {
      vanStepsMonth++;
      if (vanStepsMonth > 11) {
        vanStepsMonth = 0;
        vanStepsYear++;
      }
      renderCalendar(vanStepsMonth, vanStepsYear, calendarID, calendarType);
    } else {
      visitUsMonth++;
      if (visitUsMonth > 11) {
        visitUsMonth = 0;
        visitUsYear++;
      }
      renderCalendar(visitUsMonth, visitUsYear, calendarID, calendarType);
    }
  });

document
  .querySelector(".visitUs #prevMonth")
  .addEventListener("click", function () {
    console.log(visitUsMonth, "visitUsMonth");
    console.log(visitUsMonth, "visitUsMonth");
    if (calendarType === ".vanSteps") {
      vanStepsMonth--;
      if (vanStepsMonth < 0) {
        vanStepsMonth = 11;
        vanStepsYear--;
      }
      renderCalendar(vanStepsMonth, vanStepsYear, calendarID, calendarType);
    } else {
      visitUsMonth--;
      if (visitUsMonth < 0) {
        visitUsMonth = 11;
        visitUsYear--;
      }
      renderCalendar(visitUsMonth, visitUsYear, calendarID, calendarType);
    }
  });
